import {ContentsType} from '../constants';
import {ContentsTypeLabel} from '../locales';

export const getContentsTypeLabel = (type: ContentsType) =>
	ContentsTypeLabel[type];

export default getContentsTypeLabel;
